import {CheatSheet} from "./cheatsheet";

const arbitrarySupportedClasses = {
  pt: "padding-top",
  pb: "padding-bottom",
  pl: "padding-left",
  pr: "padding-right",
  p: "padding",
  mb: "margin-bottom",
  m: "margin",
  mt: "margin-top",
  ml: "margin-left",
  mr: "margin-right",
  w: "width",
  h: "height",
  top: "top",
  bottom: "bottom",
  left: "left",
  right: "right",
  bg: "background",
  border: "border-color",
  text: "color",
  aspect: "aspect-ratio",
  color: "color",
  "max-w": "max-width",
  "max-h": "max-height",
};

export const convertToCss = (classNames: string[]) => {
  let cssCode = ``;
  CheatSheet.forEach((element) => {
    element.content.forEach((content) => {
      content.table.forEach((list) => {
        if (classNames.includes(list[0])) {

          cssCode += `${list[1]} \n`;
        }

        if (classNames.includes(list[1])) {
          const semicolon = list[2][list[2].length - 1] !== ";" ? ";" : "";
          cssCode += `${list[2]}${semicolon} \n`;
        }
      });
    });
  });

  // Check for arbitrary values

  const arbitraryClasses = classNames.filter((className) =>
    className.includes("[")
  );

  arbitraryClasses.forEach((className) => {
    try {
      const property = className.split("-[")[0].replace(".", "");

      const properyValue = className.match(/(?<=\[)[^\][]*(?=])/g)[0];
      if (arbitrarySupportedClasses[property]) {
        cssCode += `${arbitrarySupportedClasses[property]}: ${properyValue};\n`;
      }
    }
    catch (e) {
      console.log(e)
    }
  });

  return cssCode;
};
